/* Api methods to call /functions */

const create = (data) => {
  return fetch('/.netlify/functions/todos-create', {
    body: JSON.stringify(data),
    method: 'POST'
  }).then(response => {
    return response.json()
  })
}

const readParams = () => {
  return fetch('/.netlify/functions/todos-params').then((response) => {
    return response.json()
  })
}

const readAll = () => {
  return fetch('/.netlify/functions/todos-read-all').then((response) => {
    return response.json()
  })
}

const readAllCountry = () => {
  return fetch('/.netlify/functions/todos-read-all-country').then((response) => {
    return response.json()
  })
}

const readAllCouponStatus = (data) => {
  return fetch('/.netlify/functions/todos-read-all-coupon-status', {
    body: JSON.stringify(data),
    method: 'POST'
  }).then((response) => {
    return response.json()
  })
}

const readAllFeatured = () => {
  return fetch('/.netlify/functions/todos-read-all-featured').then((response) => {
    return response.json()
  })
}

const update = (todoId, data) => {
  return fetch(`/.netlify/functions/todos-update/${todoId}`, {
    body: JSON.stringify(data),
    method: 'POST'
  }).then(response => {
    return response.json()
  })
}

const deleteTodo = (todoId) => {
  return fetch(`/.netlify/functions/todos-delete/${todoId}`, {
    method: 'POST',
  }).then(response => {
    return response.json()
  })
}

const batchDeleteTodo = (todoIds) => {
  return fetch(`/.netlify/functions/todos-delete-batch`, {
    body: JSON.stringify({
      ids: todoIds
    }),
    method: 'POST'
  }).then(response => {
    return response.json()
  })
}

const sendGrid = (data) => {
  return fetch('/.netlify/functions/todos-send-grid', {
    body: JSON.stringify(data),
    method: 'POST'
  }).then((response) => {
    return response.json()
  })
}

const mailGun = (data) => {
  return fetch('/.netlify/functions/todos-mail-gun', {
    body: JSON.stringify(data),
    method: 'POST'
  }).then((response) => {
    return response.json()
  })
}

const aliyun = (data) => {
  return fetch('/.netlify/functions/todos-aliyun', {
    body: JSON.stringify(data),
    method: 'POST'
  }).then((response) => {
    return response.json()
  })
}

export default {
  create: create,
  readParams: readParams,
  readAll: readAll,
  readAllCountry: readAllCountry,
  readAllCouponStatus: readAllCouponStatus,
  readAllFeatured: readAllFeatured,
  update: update,
  delete: deleteTodo,
  batchDelete: batchDeleteTodo,
  sendGrid: sendGrid,
  mailGun: mailGun,
  aliyun: aliyun
}
